// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"Toolbar_swiper-slide-active__Y6NSw","wrapper":"Toolbar_wrapper__mI4-T","customDropdown":"Toolbar_customDropdown__rz7Ib","right":"Toolbar_right__dwHtQ"};